import { useRouter } from 'next/router'

import { withUserContext } from 'context'

//* Components
import { Text, Icon } from 'components/common'

//* Style
import ButtonCreateDebateBigStyle from './style'

const ButtonCreateDebateBig = (props) => {

    const router = useRouter()

    const handleDebateCreate = () => {
        if (props.isLoggedIn) {
            router.push('/profile/debate/create')
        } else {
            router.push(`${router.asPath}?c=login`)
        }
    }

    return (
        <ButtonCreateDebateBigStyle
            className={`cursorPointer flexBox ${props.className ? props.className : ''}`}
            onClick={handleDebateCreate}>
            <Text tag={'p'} className={'circle h5 PopSemi white'} >
                <Icon className='op-plus' />
            </Text>
            <Text tag={'p'} className={'h5 PopSemi purple'} text={props.content} />
        </ButtonCreateDebateBigStyle>
    )
}

export default withUserContext(ButtonCreateDebateBig, ['isLoggedIn'])
